/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../redux/hooks";
import { InsuranceTable } from "./InsuranceTable";
import { setInsuranceCompanies } from "../../../redux/reducers";
import { Container } from "../../../globalstyled";
import { AddCompany } from "./AddCompany";
import AppLoader from "../../../components/loader";
import {
  insuranceCompaniesResponse,
  InsuranceCompany,
} from "../../../types/graphQlQuery.interface";
import { useQuery } from "@apollo/client";
import { GET_INSURANCE_COMPANIES } from "../../../apolloClient/operation/querys/userQuery";
import { useAccess } from "../../../hooks/useAccess";
import { logEvent, INSURANCE_EVENTS } from "../../../utils/amplitude";

interface DashboardProps {}

export const InsuranceCompanies: React.FC<DashboardProps> = ({}) => {
  const dispatch = useDispatch();
  const userReducer = useAppSelector((state) => state.userReducer);
  const { insuranceCompanies } = userReducer;

  const [addCompany, setAddCompany] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectedInsurance, setSelectedInsurance] =
    useState<InsuranceCompany | null>(null);

  const { loading, error, data, refetch } =
    useQuery<insuranceCompaniesResponse>(GET_INSURANCE_COMPANIES, {
      variables: { limit: 100, offset: 0 },
    });

  useEffect(() => {
    onFetchInsuranceCompany();
  }, [loading, error, data, dispatch, addCompany]);

  // Use the global hook for access permissions
  const { loading: accessLoading } = useAccess();

  // Fetch permissions from Redux using useAppSelector
  const permissions = useAppSelector((state) => state.userReducer.permissions);

  const onFetchInsuranceCompany = () => {
    if (!loading && !error && data) {
      dispatch(setInsuranceCompanies(data.insuranceCompanies));
      
      // Track page viewed
      if (!addCompany) {
        logEvent(INSURANCE_EVENTS.COMPANIES_PAGE_VIEWED, { company_count: data.insuranceCompanies.length });
      }
      setIsLoading(false);
    } else if (error) {
      console.error("Error fetching insurance company:", error);
      setIsLoading(false);
    }
  };

  const handleEditInsurance = (insurance: InsuranceCompany) => {
    setSelectedInsurance(insurance);
    onDisplayAddCompany();
  };

  const onDisplayAddCompany = () => {
    setAddCompany(!addCompany);
  };

  if (isLoading || accessLoading) {
    return <AppLoader isLoading={isLoading || accessLoading} />;
  }

  // Check if the user has write access for the "Insurance" section
  const hasWriteAccess = permissions.some(
    (permission) => permission.name === "INSURANCE_PROVIDER" && permission.permission.includes("WRITE")
  );

  const hostContainer = () => {
    if (addCompany) {
      return (
        <Container>
          <AddCompany
            onTapAdd={() => {
              setAddCompany(false);
              setSelectedInsurance(null);
              refetch();
            }}
            company={selectedInsurance}
            onCancel={() => {
              setAddCompany(false);
              setSelectedInsurance(null);
            }}
          />
        </Container>
      );
    } else {
      return (
        <Container>
          <InsuranceTable
            insuranceCompanies={
              Array.isArray(insuranceCompanies) ? insuranceCompanies : []
            }
            onTapAddCompany={() => onDisplayAddCompany()}
            onEditInsurance={handleEditInsurance}
            refetch={refetch}
            permissions={hasWriteAccess}
          />
        </Container>
      );
    }
  };

  return hostContainer();
};
